import { getProjectName } from "@/components/_shared/menu/actions";
import { useState, useEffect } from "react";

export default function useRecentProject() {
  const [recentProject, setRecentProject] = useState<{
    id: string;
    name: string;
  } | null>(null);

  useEffect(() => {
    const getCookie = (name: string) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(";").shift();
      return null;
    };

    const projectId = getCookie("ps_recent_projects");
    if (projectId) {
      setRecentProject({ id: projectId, name: "" });
      getProjectName(projectId).then((x) => setRecentProject({ id: projectId, name: x || "" }));
    }
  }, []);

  return recentProject;
}